import { ElementNode } from "dynamo-models";
import { observer } from "mobx-react";
import React from "react";
import { DynComponent, stateToProps } from ".";
import { NodeProps } from "..";
import { connect } from "react-redux";
import { getFactory, dispatchToProps } from "./dynComponent";

class ElementComponent extends DynComponent<ElementNode> {
    constructor(props) {
        super(props);
        this.innerRender = ({ children }) => getFactory(this.props).CreateComponent(children, this.props);
        props.factory.Prepare(props.node);
    }

    public innerRender: (children) => JSX.Element;
    public render() {
        let keyIndex = 0;

        const copyProps = (v: ElementNode) => NodeProps.CopyFor(this.props, v, keyIndex++);

        return (
            <this.innerRender>
                {this.props.node.children.map((v) => <ElementWidget {...copyProps(v)} key={v.nodeId} />)}
            </this.innerRender>
        );
    }
}

export const ElementWidget = connect(stateToProps, dispatchToProps)(ElementComponent);
